/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Travelcenter'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> ------------------------------------------------
    travelcenter_usersbookings: [],
    travelcenter_usersbookings_filtered: [],
    travelcenter_nextBooking: null,
    travelcenter_nextFlight: null,
    // >>> ------------------------------------------------
    shared_filterSearchTravelcenterBookings_Params: null, // search/filer param
    // >>> ------------------------------------------------
    shared_getCountries: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: Travelcenter
    ***************************************************************************/
    /***************************************************************************
    * get_Travelcenter_UsersBookings()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_UsersBookings: state => {

        return state.travelcenter_usersbookings;

    }, // eo function get_Travelcenter_UsersBookings()


    /***************************************************************************
    * get_Travelcenter_UsersBookings_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_UsersBookings_Filtered: state => {

        return state.travelcenter_usersbookings_filtered;

    }, // eo function get_Travelcenter_UsersBookings_Filtered()


    /***************************************************************************
    * get_Travelcenter_UsersBookings_Length()
    *
    * Desc: Return summed up Lengths if all 'Year Arrays'.
    * Note:
    *
    */
    get_Travelcenter_UsersBookings_Length: state => {

        let summedUpLength = 0;


        Object.keys(state.travelcenter_usersbookings).forEach((year) => {
            summedUpLength += state.travelcenter_usersbookings[year].length;
        });


        return summedUpLength;

    }, // eo function get_Travelcenter_UsersBookings_Length()


    /***************************************************************************
    * get_Travelcenter_UsersBookings()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_NextFlight: state => {

        return state.travelcenter_nextFlight;

    }, // eo function get_Travelcenter_NextFlight()




    /***************************************************************************
    * Getters: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * get_Shared_Countries()
    *
    * Desc:
    * Note:
    *
    */
    get_Shared_Countries: state => {

        return state.shared_getCountries;

    }, // eo function get_Shared_Countries()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: Travelcenter Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_travelcenter_updateProfile()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_updateProfile: (state, payload) => {

        Vue['ls'].set('authorizationUserdata', JSON.stringify(payload.response), 60 * 60 * 1000);

    }, // eo function mut_call_travelcenter_updateProfile()


    /***************************************************************************
    * mut_call_travelcenter_getBookingsOLd()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_getBookingsOLd: (state, payload) => {

        let nextBooking = null,
            nextFlight = null,
            getBookings_StructuredByYear = {};


        // >>> sort every flight in every booking ---------
        payload.bookings.forEach(booking => {
            booking.outwardFlights.sort((a, b) => a.departureDateTime < b.departureDateTime ? 1 : -1);
            booking.inboundFlights.sort((a, b) => a.departureDateTime < b.departureDateTime ? 1 : -1);
        });

        // >>> sort complete bookings ---------------------
        payload.bookings.sort((a, b) => a.outwardFlights[0].departureDateTime < b.outwardFlights[0].departureDateTime ? 1 : -1);


        // >>> find next Booking (via next flight) --------
        payload.bookings.forEach(booking => {
            for (let i = 0; i < booking.outwardFlights.length; i++) {
                let flight = booking.outwardFlights[i];

                if (moment(flight.departureDateTime).diff(moment()) > 0) {
                    // flug findet noch statt

                    if (nextFlight === null) {
                        nextFlight = flight;
                        continue;
                    }

                    if (moment(nextFlight.departureDateTime).diff(flight.departureDateTime) < 0) {
                        // flight findet VOR nextFlight statt
                        nextFlight = flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }

            for (let i = 0; i < booking.inboundFlights.length; i++) {
                let flight = booking.inboundFlights[i];

                if (moment(flight.departureDateTime).diff(moment()) > 0) {
                    // flug findet noch statt

                    if (nextFlight === null) {
                        nextFlight = flight;
                        continue;
                    }

                    if (moment(nextFlight.departureDateTime).diff(flight.departureDateTime) > 0) {
                        // flight findet VOR nextFlight statt
                        nextFlight = flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }
        });


        // >>> destructure by year of booking -------------
        payload.bookings.forEach(booking => {

            let year = moment(booking.outwardFlights[0].departureDateTime).get("year").toString();


            if (year in getBookings_StructuredByYear) {
                getBookings_StructuredByYear[year].push(booking);
            } else {
                getBookings_StructuredByYear[year] = [];
                getBookings_StructuredByYear[year].push(booking);
            }

        });



        // >>> set ----------------------------------------
        state.travelcenter_usersbookings = getBookings_StructuredByYear; // payload;
        state.travelcenter_usersbookings_filtered = getBookings_StructuredByYear; // payload;
        state.travelcenter_nextBooking = nextBooking;
        state.travelcenter_nextFlight = nextFlight;

    }, // eo function mut_call_travelcenter_getBookingsOLd()

    /***************************************************************************
    * mut_call_travelcenter_getBookings()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_getBookings: (state, payload) => {

        let flight = null,
            year = null,
            nextBooking = null,
            nextFlight = null,
            getBookings_StructuredByYear = {};


        // >>> buil iso date times ------------------------
        payload.forEach(booking => {
            booking.departureDateTime = moment(booking.date + ' ' + booking.departureTime, 'DD.MM.YY HH:mm').format('YYYY-MM-DDTHH:mm:ss+0000');
            booking.arrivalDateTime = moment(booking.date + ' ' + booking.arrivalTime, 'DD.MM.YY HH:mm').format('YYYY-MM-DDTHH:mm:ss+0000');
        });


        // >>> sort complete bookings --------------------- enough?
        payload.sort((a, b) => a.departureDateTime > b.departureDateTime ? 1 : -1);


        // >>> find next Booking (via next flight) --------
        payload.forEach(booking => {
            flight = booking;

            if (moment(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').get("year").toString() === moment().get("year").toString()) {
                if (moment(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').diff(moment()) > 0) { // flug findet noch statt
                    if (nextFlight === null) {
                        nextFlight = flight;
                    }

                    if (moment(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').diff(nextFlight.departureDateTime) < 0) { // flight findet VOR nextFlight stat
                        nextFlight = flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }


        });


        // >>> destructure by year of booking ------------- ok
        payload.forEach(booking => {

            year = moment(booking.date, 'DD.MM.YY').get("year").toString();

            if (year in getBookings_StructuredByYear) {
                getBookings_StructuredByYear[year].push(booking);
            } else {
                getBookings_StructuredByYear[year] = [];
                getBookings_StructuredByYear[year].push(booking);
            }

        });


        // >>> set ----------------------------------------
        state.travelcenter_usersbookings = getBookings_StructuredByYear; // payload;
        state.travelcenter_usersbookings_filtered = getBookings_StructuredByYear; // payload;
        state.travelcenter_nextFlight = nextFlight;

    }, // eo function mut_call_travelcenter_getBookings()




    /***************************************************************************
    * Mutations: Travelcenter, Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterSearchTravelcenterBookings()
    *
    * Desc: Set Search/Filter Terms.
    * Note: Filter right afterwards.
    *
    */
    mut_set_filterSearchTravelcenterBookings: (state, payload) => {

        state.shared_filterSearchTravelcenterBookings_Params = payload.payload;
        payload.context.commit('mut_filterSearchTravelcenterBookings', payload.payload); // now filter

    }, // eo function mut_set_filterSearchTravelcenterBookings()


    /***************************************************************************
    * mut_filterSearchTravelcenterBookings()
    *
    * Desc:
    * Note: Shallow, Deep Copy.
    *
    */
    mut_filterSearchTravelcenterBookings: (state, payload) => {

        // const gl_travelcenter_getBookings = {...state.travelcenter_usersbookings}; // copy it, shallow
        const gl_travelcenter_getBookings = JSON.parse(JSON.stringify(state.travelcenter_usersbookings)); // copy it, deep


        if (gl_travelcenter_getBookings !== null) {

            for (const [year, bookingsOfAYear] of Object.entries(gl_travelcenter_getBookings)) {

                gl_travelcenter_getBookings[year] = bookingsOfAYear.filter(booking => {

                    let applyFilter = false;

                    if (booking.aptFrom.match(new RegExp(payload, 'i')) ||
                        booking.aptTo.match(new RegExp(payload, 'i')) ||
                        booking.flightNo.match(new RegExp(payload, 'i'))
                        ) {
                        applyFilter = true;
                    }

                    booking.paxes.forEach(pax => {
                        if (pax.bookingCode.match(new RegExp(payload, 'i'))) {
                            applyFilter = true;
                        }
                    });

                    booking.services.forEach(service => {
                        if (service.bookingCode.match(new RegExp(payload, 'i'))) {
                            applyFilter = true;
                        }
                    });

                    return applyFilter;

                });


                if (gl_travelcenter_getBookings[year].length === 0) {
                    delete (gl_travelcenter_getBookings[year]);
                }
            }

            state.travelcenter_usersbookings_filtered = gl_travelcenter_getBookings;

        }

    }, // eo function mut_filterSearchTravelcenterBookings()




    /***************************************************************************
    * Mutations: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * mut_call_shared_getCountries()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_shared_getCountries: (state, payload) => {

        payload.sort((a, b) => a.name > b.name ? 1 : -1);
        state.shared_getCountries = payload;

    }, // eo function mut_call_shared_getCountries()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: Travelcenter Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/profile/update';
    *
    * Desc: Call: Update an user.
    * Note: On password update log out user.
    *
    */
    actn_call_travelcenter_updateProfile: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/profile/update', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_travelcenter_updateProfile', { response: response.data }, { root: true });
                        eventBus.$emit('call_travelcenter_updateProfile_success');

                        // password update case
                        if ("password" in payload) {
                            eventBus.$emit('call_travelcenter_updateProfile_updatePasswordSuccess'); // works
                        }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_travelcenter_updateProfile()


    /***************************************************************************
    * Call::'/booking/profile/bookings/'; (old)
    * Call::'/booking/profile/active/'; (actual)
    *
    * Desc: Call: Get Users Bookings.
    * Note: New: With 'Security' Authorization Header.
    *
    */
    actn_call_travelcenter_getBookings: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/profile/active/', { 'email': payload.user_email }, {
            headers: {
                "Authorization": "Basic " + payload.authorizationHeader
            }})
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_travelcenter_getBookings', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_travelcenter_getBookings()




    /***************************************************************************
    * Actions: Travelcenter, Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * act_set_filterSearchTravelcenterBookings()
    *
    * Desc: Save Search/Filter Params for Bookings.
    * Note:
    *
    */
    act_set_filterSearchTravelcenterBookings: (context, payload) => {

        context.commit('mut_set_filterSearchTravelcenterBookings', { payload: payload, context: context });

    }, // eo function act_set_filterSearchTravelcenterBookings()





    /***************************************************************************
    * Actions: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/info/countries';
    *
    * Desc: Call: Get Countries.
    * Note:
    *
    */
    actn_call_shared_getCountries: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/info/countries')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_shared_getCountries', response.data);
                        eventBus.$emit('call_shared_countries_success');

                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_shared_getCountries()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/travelcenter/travelcenter.js